import "./css/general/fonts.css"
import "./css/general/variables.css"
import "./css/general/util.css"
import "./css/general/typography.css"
import "./css/general/layout.css"
import "./css/general/accessability.css"

/* BEGIN cities */
/* only cities with custom styling and logo have their own css file, the rest is in general/cities.css */
import "./css/general/cities.css"
import "./css/general/cities/bern.css"
/* import "./css/general/cities/chur.css" */
import "./css/general/cities/biel.css"
import "./css/general/cities/kloten.css"
import "./css/general/cities/luzern.css"
import "./css/general/cities/st-gallen.css"
/* import "./css/general/cities/winterthur.css" */
import "./css/general/cities/zuerich.css"
/* END cities */

import "./css/components/animations.css"
import "./css/components/icons.css"
import "./css/components/button.css"
import "./css/components/emergency.css"
import "./css/components/form.css"
import "./css/components/step.css"
import "./css/components/modal.css"
import "./css/components/checkboxes.css"
import "./css/components/contents.css"
import "./css/components/loading.css"
import "./css/components/nav.css"
import "./css/components/help.css"
import "./css/components/message.css"
import "./css/components/download.css"
import "./css/components/custom-select.css"
import "./css/components/summary.css"

import { render } from "preact"
import { Form } from "./js/components/form"
import { Menu } from "./js/components/menu"
import { qs } from "./js/util/dom"
import { Endpoint } from "./js/util/endpoint"

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const menuEl = qs("#menu")
    if (menuEl)
      render(
        <Menu
          ep={new Endpoint(menuEl.dataset.endpoint)}
          contactEp={new Endpoint(menuEl.dataset.contactEndpoint)}
        />,
        menuEl,
      )

    const appEl = qs("#meldetool")
    if (appEl)
      render(
        <Form
          ep={new Endpoint(appEl.dataset.endpoint)}
          contactEp={new Endpoint(appEl.dataset.contactEndpoint)}
        />,
        appEl,
      )

    const loadingscreen = document.querySelector(".loading-screen")
    if (loadingscreen) {
      setTimeout(() => {
        loadingscreen.classList.add("collapse")
      }, 800)
    }
  },
  false,
)
